import { Box, Button, Typography } from '@mui/material';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { paths } from 'routes';
import { fontSize, colors } from 'theme';

export const CrisisLogged: FunctionComponent = () => {
  const intl = useIntl();
  return (
    <Box
      style={{
        display: 'flex',
        height: '90%',
        justifyContent: 'space-between',
        flexDirection: 'column',
      }}
    >
      <Box style={{ flex: 1 }}>
        <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '5vh' }}>
          <Typography
            align="center"
            fontSize={fontSize.large}
            fontFamily="Poppins Medium"
            style={{ marginBottom: '2vh', color: colors.darkPurple }}
          >
            {intl.formatMessage({ id: 'crisis-logged.title' })}
          </Typography>
        </Box>
      </Box>
      <Button
        variant="contained"
        color="primary"
        style={{
          height: '45px',
          width: '100%',
          margin: '1vh 0',
          color: colors.white,
          backgroundColor: colors.darkPurple,
        }}
        component={Link}
        to={paths.RECORD_CRISIS}
      >
        {intl.formatMessage({ id: 'crisis-logged.another' })}
      </Button>
      <Button
        variant="contained"
        color="primary"
        style={{
          height: '45px',
          width: '100%',
          margin: '1vh 0',
          color: colors.white,
          backgroundColor: colors.darkPurple,
        }}
        component={Link}
        to={paths.RECORD}
      >
        {intl.formatMessage({ id: 'record-logged.different' })}
      </Button>
      <Box style={{ flex: 1 }}>
        <Button
          variant="contained"
          color="primary"
          style={{
            height: '45px',
            width: '100%',
            margin: '1vh 0',
            color: colors.white,
            backgroundColor: colors.darkPurple,
          }}
          component={Link}
          to={paths.CRISIS_HISTORY}
        >
          {intl.formatMessage({ id: 'crisis-logged.history' })}
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{
            height: '45px',
            width: '100%',
            margin: '1vh 0',
            color: colors.white,
            backgroundColor: colors.darkPurple,
          }}
          component={Link}
          to={paths.HOME_MENU}
        >
          {intl.formatMessage({ id: 'crisis-logged.menu' })}
        </Button>
      </Box>
      <Box style={{ flex: 1 }}></Box>
    </Box>
  );
};
